import { render, staticRenderFns } from "./AccountLinks.vue?vue&type=template&id=75672062&scoped=true"
import script from "./AccountLinks.vue?vue&type=script&lang=ts"
export * from "./AccountLinks.vue?vue&type=script&lang=ts"
import style0 from "./AccountLinks.vue?vue&type=style&index=0&id=75672062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75672062",
  null
  
)

export default component.exports